export class ordinal {

    /**
     * Converts a number to its english spoken ordinal value. 
     * i.e. 1,2,3,4 => 1st, 2nd, 3rd, 4th, etc.
     * @param n Number used to produce ordinal value
     * @returns String ordinal representation of a number
     */
    static getNumberOrdinal(n: number) {
        var s = ["th", "st", "nd", "rd"];
        var v = n % 100;
        return n + (s[(v - 20) % 10] || s[v] || s[0]);
    }

}
